import { useNavigate } from "react-router-dom";

export default function FormSuccess({ title, message }) {
  const navigate = useNavigate();
  return (
    <div className="form-success fade-up">
      <div className="fs-ic">✅</div>
      <h2>{title}</h2>
      <p>{message}</p>
      <button className="btn-g" onClick={() => navigate("/")}>Return to Home</button>
    </div>
  );
}
